export default String.raw`
.check-availability {
    .dialog {
        &__header {
            padding: 24px 16px 16px 16px;
        
            &-title {
                @include h3-headline;
            }
        }

        &__content {
            padding: 16px;
        }
    }
}
`